/**
 * Array utilities
 * Centralizes common array manipulation patterns for safe array operations
 */

/**
 * Safely get array length, returns 0 if not an array
 * Centralizes the pattern: Array.isArray(x) ? x.length : 0
 *
 * @param value - Value to check
 * @returns Array length or 0 if not an array
 */
export function safeArrayLength(value: unknown): number {
	return Array.isArray(value) ? value.length : 0;
}
